import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base-service';

@Injectable({
  providedIn: 'root',
})
export class TypescriptService extends BaseService{
  backendUrl: string = environment.backendTypescriptFastifyUrl;
  constructor(private httpClient: HttpClient) {
    super();
  }
  hello(): Observable<Record<string, unknown>> {
      return this.httpClient.get<Record<string, unknown>>(this.backendUrl + "hello");
    }
  notificar(titulo: string, texto: string): Observable<{ mensaje: string }> {
    return this.httpClient.post<{ mensaje: string }>(this.backendUrl + 'notificacion', { titulo, texto });
  }
  readonly helloResource = httpResource.text(() => ({

    url: this.backendUrl + 'hello',
    method: 'GET'
}));  
}
